import React from 'react';
import './Skills.css';

import { Heading } from '../../../components';
import { skills } from '../../../constants';



const Skills = () => {

  return (
    <section className="custom-form skills-section">
      <div className="box-container">
        <div className="content">
          <div className="text">

            {/* Section Heading */}
            <Heading title={skills.heading} subTitle={skills.sub} sideHeading linear />

            <p>{skills.content}</p>

            {/* Key Benefits */}
            <div className="why-points">
              {skills.points.map((point) => (
                <div className="box" key={point.id}>
                  <h3>
                    {point.title}
                    <span> {point.progress}% </span>
                  </h3>
                  <div className="progress-bar">
                    <span style={{ width: `${point.progress}%` }}></span>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;